import type { QuestDoneEvent } from '@xox/shared'
import { CheckCircle2 } from 'lucide-react'
import { useEffect } from 'react'

const TOAST_MS = 6_000

/** "Quest complete · Beat a boss · +30 XP"; goes away on its own. */
export function QuestToast({ ev, onDismiss }: { ev: QuestDoneEvent; onDismiss: () => void }) {
  useEffect(() => {
    const id = setTimeout(onDismiss, TOAST_MS)
    return () => clearTimeout(id)
  }, [onDismiss])
  return (
    <div
      onClick={onDismiss}
      onKeyDown={(e) => e.key === 'Enter' && onDismiss()}
      role="button"
      tabIndex={0}
      className="flex cursor-pointer items-center gap-3"
    >
      <CheckCircle2 className="size-9 shrink-0" aria-hidden />
      <div className="min-w-0 flex-1">
        <div className="text-[10px] font-black uppercase tracking-[0.2em] text-emerald-100">
          Quest complete
        </div>
        <div className="truncate text-sm font-black leading-tight">{ev.quest.title}</div>
      </div>
      <div className="shrink-0 rounded-full bg-white/20 px-2.5 py-1 text-xs font-black tabular-nums">
        +{ev.xp} XP
      </div>
    </div>
  )
}
